import React, { useState } from 'react';
import { UploadCloudIcon } from 'lucide-react';
export function FileUploader() {
  const [isDragging, setIsDragging] = useState(false);
  const [files, setFiles] = useState<File[]>([]);
  const handleDragOver = (e: React.DragEvent) => {
    e.preventDefault();
    setIsDragging(true);
  };
  const handleDragLeave = () => {
    setIsDragging(false);
  };
  const handleDrop = (e: React.DragEvent) => {
    e.preventDefault();
    setIsDragging(false);
    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      const newFiles = Array.from(e.dataTransfer.files);
      setFiles(prev => [...prev, ...newFiles]);
    }
  };
  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files.length > 0) {
      const newFiles = Array.from(e.target.files);
      setFiles(prev => [...prev, ...newFiles]);
    }
  };
  const removeFile = (index: number) => {
    setFiles(files.filter((_, i) => i !== index));
  };
  return <div data-id="element-938">
      <div onDragOver={handleDragOver} onDragLeave={handleDragLeave} onDrop={handleDrop} className={`border-2 border-dashed rounded-lg p-6 text-center cursor-pointer transition-colors ${isDragging ? 'border-blue-500 bg-blue-50' : 'border-gray-300 hover:border-gray-400'}`} data-id="element-939">
        <input type="file" id="file-upload" onChange={handleFileChange} className="hidden" multiple data-id="element-940" />
        <label htmlFor="file-upload" className="cursor-pointer" data-id="element-941">
          <UploadCloudIcon className="mx-auto h-12 w-12 text-gray-400" data-id="element-942" />
          <p className="mt-2 text-sm font-medium text-gray-900" data-id="element-943">
            Drag and drop files here or click to browse
          </p>
          <p className="mt-1 text-xs text-gray-500" data-id="element-944">
            Upload multiple files at once
          </p>
        </label>
      </div>
      {files.length > 0 && <div className="mt-4" data-id="element-945">
          <h4 className="text-sm font-medium mb-2" data-id="element-946">Uploaded Files</h4>
          <ul className="space-y-2" data-id="element-947">
            {files.map((file, index) => <li key={index} className="flex items-center justify-between bg-gray-100 p-2 rounded" data-id="element-948">
                <span className="text-sm truncate" data-id="element-949">{file.name}</span>
                <button onClick={() => removeFile(index)} className="text-red-500 hover:text-red-700" data-id="element-950">
                  ✕
                </button>
              </li>)}
          </ul>
        </div>}
    </div>;
}